module.exports = __webpack_public_path__ + "img/wjj.9c769169.svg";